import React from "react";
import { Link } from "react-router-dom";
import { Logo } from "@/components/Logo";
import { Disclaimer } from "@/components/Disclaimer";
import { useAssessments } from "@/hooks/useAssessments";

export function Footer() {
  const { assessments } = useAssessments();
  return (
    <footer className="relative border-t border-slate-800/60 bg-slate-950">
      <div className="mx-auto max-w-7xl px-5 py-16 sm:px-8">
        <div className="grid gap-10 md:grid-cols-4">
          <div className="md:col-span-2">
            <Logo />
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-slate-500">
              The operating system for your inner world. Map the hidden patterns running your life and receive a
              personalized roadmap for growth that evolves with you.
            </p>
          </div>
          <div>
            <h4 className="mb-3 text-xs font-bold uppercase tracking-[0.2em] text-teal-500">Assessments</h4>
            <ul className="space-y-2.5 text-sm text-slate-400">
              {assessments.slice(0, 6).map((a) => (
                <li key={a.slug}><Link to={`/a/${a.slug}`} className="hover:text-teal-300">{a.short}</Link></li>
              ))}
              <li><Link to="/#all" className="font-medium text-teal-400 hover:text-teal-300">See all 12 →</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="mb-3 text-xs font-bold uppercase tracking-[0.2em] text-teal-500">Platform</h4>
            <ul className="space-y-2.5 text-sm text-slate-400">
              <li><Link to="/about" className="hover:text-teal-300">Meet Avnni</Link></li>
              <li><Link to="/dashboard" className="hover:text-teal-300">Your Dashboard</Link></li>
              <li><Link to="/privacy" className="hover:text-teal-300">Privacy</Link></li>
              <li><Link to="/terms" className="hover:text-teal-300">Terms</Link></li>
              <li><Link to="/disclaimer" className="hover:text-teal-300">Disclaimer</Link></li>
            </ul>
          </div>
        </div>
        <div className="mt-12"><Disclaimer /></div>
        <div className="mt-8 flex flex-col items-start justify-between gap-3 border-t border-slate-800/60 pt-6 text-xs text-slate-600 sm:flex-row sm:items-center">
          <p>© {new Date().getFullYear()} TheInner.app · A living profile, not a label.</p>
          <p className="font-mono">Grounded in psychology + depth work</p>
        </div>
      </div>
    </footer>
  );
}
